<template>
  <modal
    :title="$t('Zones.zone_pricing')"
    @close-request="$emit('closeModal')"
    closable
  >
  <div >
    <heat-map-modal v-if="showModal" 
    @closeModal="closeModal" 
    :coordinates="zones" 
    :currentZone="zone.zoneName" 
    :hoveredZone="hoveredZone"
    @mouseover="offHover"
    >
  </heat-map-modal>

  </div>
  <div style="width: 100%; padding: 0 2rem">
    <h4 class="kne-title" style="margin-bottom: 20px;">{{zone.zoneName}}</h4>
    <div style="display: flex; gap: 10px" v-if="!toZone">
      <regular-select
              :placeholder="$t('Zones.select_zone')"
              style="flex: 2"
              @change="selectedZone = $event"
              class="border form-group" v-model="selectedZone">
              <option v-for="(zon, index) in zones"
                  :key="index"
                  :value="zon.id"
                  v-if="zon.id!==zone.id">
              {{ zon.zoneName }}
              </option>
      </regular-select>
      <button @click="cloneData()" class="btn btn-kne-orange" style="height: calc(2.25rem + 2px); margin-top: 0%;">{{$t('Zones.clone')}}</button>
    </div>

    <div style="display: flex; gap: 5px;" class="m-b-8 tm-ctr" v-if="!toZone">
      <regular-select style="margin: 0%;"
        :placeholder="$t('Zones.select_time')"
        @change="selectedField = $event"
        class="border form-group tm-slt" v-model="selectedField">
          <option value="WARNING">WARNING TIME</option>
          <option value="LATE">LATE TIME</option>
      </regular-select>
      <div style="display: flex; gap: 0">
        <button class="w-btn n-b-r" :class="{ 'active': operation === '+' }" @click="operation='+'">+</button>
        <button class="w-btn" :class="{ 'active': operation === '-' }" @click="operation='-'">-</button>
      </div>
      <regular-input min="0" class="tm-inp" :value="time" @input="time = $event" type="number" :placeholder="$t('Zones.enter_time')"/>
      <button class="btn btn-kne-orange m-0" @click="updateZoneTime(selectedField, operation)">{{$t('Zones.update')}}</button>
    </div>

    <div ref="datatableContainer" id="datatable" class="display"></div>
    <div class="btn-div">
      <button class="btn btn-blk btn-cnl" @click="$emit('closeModal')">{{$t('Zones.cancel')}}</button>
      <button @click="saveData()" class="btn btn-kne-orange">{{$t('Zones.save')}}</button>
    </div>
  </div>
</modal>
</template>

<script>
import Modal from '../../interface-components/Modal.vue'
import DataTable from 'frappe-datatable'
import { point, distance } from '@turf/turf'
import 'frappe-datatable/dist/frappe-datatable.min.css'
import { db } from '../../../../firebase'
import RegularSelect from '../../basic-components/regularSelect.vue'
import RegularInput from '../../basic-components/regularInput.vue'
import HeatMapModal from '../Modal-templates/HeatMap-modal.vue'

export default {
  components: {
    Modal,
    RegularSelect,
    RegularInput,
    HeatMapModal
  },
  data () {
    return {
      zones: [],
      zoneIds: {},
      zoneDistances: {},
      datatable: null,
      time: '',
      operation: '+',
      selectedField: '',
      selectedZone: '',
      showModal: false,
      hoveredZone: '',
      zoneCellClass: '.dt-cell__content.dt-cell__content--col-1',
      hasDatatableListeners: false

    }
  },
  props: {
    zone: Object,
    toZone: String
  },
  methods: {
    onHover (e, item) {
      this.hoveredZone = e.srcElement.innerText
      item.style.background = '#008000'
      item.style.color = '#fff'
      item.style.transition = 'all 200ms'
      this.openModal()
    },
    offHover (item) {
      item.style.background = 'transparent'
      item.style.color = '#000'
      item.style.transition = 'all 200ms'
      this.closeModal()
    },
    openModal () {
      this.showModal = true
    },
    closeModal () {
      this.showModal = false
    },
    async getZones () {
      // Use zones from store
      if (!this.$store.state.zonesLoaded) {
        await this.$store.dispatch('subscribeToZones')
      }
      const storeZones = this.$store.state.zones
      if (storeZones.length) {
        this.zones = storeZones.map(zone => ({ ...zone }))
        const mainCenter = this.zone.center
        this.zones.forEach(zone => {
          const center = zone.center
          zone.distance = this.calculateDistance(mainCenter, center)
          this.zoneDistances[zone.zoneName] = zone.distance
        })
      } else {
        this.zones = []
      }
      await this.renderTable()
    },
    calculateDistance (point1, point2) {
      if (!point1 || !point2) return ''
      const from = point(point1)
      const to = point(point2)
      return distance(from, to, { units: 'kilometers' })
    },
    getZonesMappedData (zoneId) {
      db.ref('database/zones/transporter').child(this.companyUID).child('zone').child(zoneId).once('value', (snapshot) => {
        if (snapshot.exists()) {
          if (Object.entries(snapshot.val()).length === 2 && zoneId !== this.zone.id) {
            confirm('No pricing details found for the selected zone')
            return
          }
          let mappedData = snapshot.val()
          this.datatable.options.data.forEach(row => {
              const data = mappedData[this.zoneIds[row[0]]]
              if (data) {
                row[2] = data.price
                row[3] = data.warningTime
                row[4] = data.lateTime
              }
            })
            this.datatable.refresh(this.datatable.options.data)
        } else {
        }
      })
    },
    updateZoneTime (selectedField, operation) {
      if (!selectedField) {
        confirm('Please select the time field')
        return
      }
      if (!operation) {
        confirm('Please select an operation')
        return
      }
      if (!this.time) {
        confirm('Please enter time')
        return
      }
      let time = Number(this.time)
      this.datatable.options.data.forEach(row => {
        const rowIndex = selectedField === 'LATE' ? 4 : 3

        if (!row[rowIndex]) {
            return
        }

        row[rowIndex] = operation === '+'
            ? Number(row[rowIndex]) + time
            : Number(row[rowIndex]) - time
      })
      this.datatable.refresh(this.datatable.options.data)
    },
    async waitForDatatableContainer () {
      for (let attempts = 0; attempts < 20; attempts++) {
        await this.$nextTick()
        if (this.$refs.datatableContainer) {
          return this.$refs.datatableContainer
        }
        await new Promise(resolve => setTimeout(resolve, 25))
      }
      return null
    },
    async renderTable () {
      const wrapper = await this.waitForDatatableContainer()
      if (!wrapper) {
        return
      }
      if (this.datatable && typeof this.datatable.destroy === 'function') {
        this.datatable.destroy()
        this.datatable = null
      }
      wrapper.innerHTML = ''
      const options = {
        layout: 'fluid',
        disableReorderColumn: true,
        columns: [
          { name: 'Zones', editable: false, minWidth: 150 },
          { name: 'Province', editable: false, minWidth: 120 },
          { name: 'Price', editable: true, minWidth: 80 },
          { name: 'Warning Time', editable: true, minWidth: 80 },
          { name: 'Late Time', editable: true, minWidth: 100 }
        ]
      }
      let data = []
      this.zones.forEach(zone => {
        this.zoneIds[zone.zoneName] = zone.id
        if (this.toZone && this.toZone !== zone.id) return
        data.push([zone.zoneName, zone.province || '', '', '', ''])
      })
      this.sortDatatable(data)
      options.data = data
      this.datatable = new DataTable(wrapper, options)
      this.datatable.options.getEditor = function (colIndex, rowIndex, value, parent, column, row, data) {
        const $input = document.createElement('input')
        $input.type = 'number'
        $input.min = 1
        $input.style.width = '100%'
        $input.style.height = '100%'
        $input.onkeydown = (event) => event.keyCode !== 69 && event.keyCode !== 189
        parent.style.padding = '0'
        parent.appendChild($input)
        $input.addEventListener('blur', () => {
          $input.dispatchEvent(new KeyboardEvent('keydown', {
            code: 'Enter',
            key: 'Enter',
            charCode: 13,
            keyCode: 13,
            view: window,
            bubbles: true
          }))
        })
        return {
          // called when cell is being edited
          initValue (value) {
            $input.focus()
            $input.style.border = 'none'
            $input.value = value
          },
          // called when cell value is set
          setValue (value) {
            $input.value = value
          },
          // value to show in cell
          getValue () {
            return $input.value
          }
        }
      }
      this.getZonesMappedData(this.zone.id)
    },
    sortDatatable (data) {
      data.sort((a, b) => {
        const provinceA = a[1]
        const provinceB = b[1]
        if (!provinceA) return 1
        if (!provinceB) return -1

        if (provinceA < provinceB) return -1
        if (provinceA > provinceB) return 1

        return this.zoneDistances[a[0]] - this.zoneDistances[b[0]]
      })
    },
    saveData () {
      this.datatable.getRows().forEach(row => {
        let setObj = {
          price: row[3]['content'],
          currency: 'CAD',
          warningTime: row[4]['content'],
          lateTime: row[5]['content']
        }
        db.ref('database/zones/transporter').child(this.companyUID).child('zone').child(this.zone.id).child(this.zoneIds[row[1]['content']]).set(
          setObj
        ).then(() => {
          console.log('Zone pricing saved')
        }).catch(function (error) {
          console.error(error)
        }).then(() => {
          this.$emit('closeModal')
        })
      })
    },
    cloneData () {
      if (!this.selectedZone) {
        confirm('Please select a zone')
        return
      }
      this.getZonesMappedData(this.selectedZone)
    },
    handleMouseOver (e) {
      const cell = e.target.closest(this.zoneCellClass)
      if (cell) {
        this.onHover(e, cell)
      }
    },
    handleMouseOut (e) {
      const cell = e.target.closest(this.zoneCellClass)
      if (cell) {
        this.offHover(cell)
      }
    }
  },
  async mounted () {
    await this.getZones()
    this.$nextTick(() => {
      const datatableContainer = this.$refs.datatableContainer
      if (!datatableContainer) return
      datatableContainer.addEventListener('mouseover', this.handleMouseOver)
      datatableContainer.addEventListener('mouseout', this.handleMouseOut)
      this.hasDatatableListeners = true
    })
  },
  beforeDestroy () {
    const datatableContainer = this.$refs.datatableContainer
    if (this.hasDatatableListeners && datatableContainer && datatableContainer.removeEventListener) {
      datatableContainer.removeEventListener('mouseover', this.handleMouseOver)
      datatableContainer.removeEventListener('mouseout', this.handleMouseOut)
    }
    this.hasDatatableListeners = false
    if (this.datatable && typeof this.datatable.destroy === 'function') {
      this.datatable.destroy()
      this.datatable = null
    }
  },
  computed: {
    companyUID () {
      return this.$store.state.authorization.company
    }
  }
}
</script>
<style>
#datatable {
  padding: 10px;
  margin-bottom: 20px;
  border-bottom: 1px solid #d1d8dd;
  overflow-x: auto;
  padding-right: 10px;
  width: 100%;
}
#datatable .dt-cell__content {
  padding-right: 15px;
  box-sizing: border-box;
  white-space: nowrap;
  overflow: visible; 
  text-overflow: clip;
}
.btn-div {
  gap: 10px;
  width: 30%;
  display: flex;
  justify-content: flex-end;
  margin-left: auto;
}
.btn-div > .btn {
  margin-top: 8px;
}
.dt-dropdown__list-item[data-index="3"] {
    display: none;
}
.n-b-r {
  border-right: none !important;
}
.tm-ctr {
  margin-bottom: 1rem;
}
.tm-ctr input {
  height: 100%;
  border: solid 1px;
}
.tm-ctr .w-btn {
  width: 35px;
  font-size: 20px;
  border: 1px solid gray;
}
.tm-inp {
  flex: 2;
}
.datatable{
    overflow-x: visible !important;
}
.dt-scrollable{
  border-right :10px solid transparent!important;
}
@media (max-width: 440px) {
  .tm-ctr {
    flex-wrap: wrap;
  }
  .tm-slt {
    flex: 2;
  }
  .tm-slt, .tm-inp {
    min-width: 40%;
  }
}
</style>
